const STORAGE_KEY = "ecf-filter-presets";

export interface FilterPreset {
  name: string;
  division: string;
  brand: string;
  country: string;
  type: string;
  owner: string;
}

export function loadPresets(): FilterPreset[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch {
    return [];
  }
}

export function savePreset(preset: FilterPreset): void {
  const presets = loadPresets().filter((p) => p.name !== preset.name);
  presets.push(preset);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(presets));
}

export function deletePreset(name: string): void {
  const presets = loadPresets().filter((p) => p.name !== name);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(presets));
}
